<template>
  <md-card
    class="md-card-tabs"
    :class="[
      { 'flex-column': flexColumn },
      { 'nav-pills-icons': navPillsIcons },
      { 'md-card-plain': plain },
    ]"
  >
    <md-card-header v-if="$slots['header-title']">
      <slot name="header-title"></slot>
    </md-card-header>
    <md-card-content>
      <md-list class="nav-tabs">
        <md-list-item
          v-for="(item, index) in tabName"
          @click="switchPanel(tabName[index])"
          :key="item"
          :class="[
            { active: isActivePanel(tabName[index]) },
            { [getColorButton(colorButton)]: isActivePanel(tabName[index]) },
          ]"
        >
          {{ tabName[index] }}
          <md-icon v-if="navPillsIcons">{{ tabIcon[index] }}</md-icon>
        </md-list-item>
      </md-list>

     <!--
      <transition name="fade" mode="out-in">
        <div class="tab-content">
          <template v-for="(item, index) in tabName">
            <template v-if="isActivePanel(tabName[index])">
              <div :class="getTabContent(index + 1)" :key="item">
                <slot :name="getTabContent(index + 1)">
                  This is the default text!
                </slot>
              </div>
            </template>
          </template>
        </div>
      </transition>
    -->
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    tabIcon: Array,
    colorButton: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activePanel: this.tabName[0],
      activeTab: 0,
    };
  },
  watch: {
  activePanel(newVal) {
    this.switchPanel(newVal);
  },
},
  methods: {
    switchPanel(panel) {
      this.activePanel = panel;
      this.$emit('update:activePanel', this.activePanel); 
    },
    isActivePanel(panel) {
      return this.activePanel == panel;
    },
    getColorButton: function (colorButton) {
      return "md-" + colorButton + "";
    },
    getTabContent: function (index) {
      return "tab-pane-" + index + "";
    },
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex; // Update activeTab when the tab changes
    },
  },
};
</script>

<style lang="css">
.md-card-tabs .md-list.nav-tabs,
.md-card-tabs .md-list-item,
.md-card-tabs .md-list-item-content,
.md-card-tabs .md-list-item-button,
.md-card-tabs .md-card-content {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.md-card-tabs.md-card,
.md-card-tabs.md-theme-default,
.md-card-tabs .md-card-content,
.md-card-tabs .md-list {
  background-color: transparent !important;
  background: none !important;
}

</style>
